import { Layout } from 'components';
import { Stack } from 'libs/ui';
import { styled, CSSObject } from 'libs/ui/styled';

export const ContainerStyled = styled(Stack)(({ theme }) => ({
  minHeight: '100%',
  flexDirection: 'row',

  '.auth-right-content': {
    flex: 1,
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden',
  } as CSSObject,
}));

export const LayoutStyled = styled(Layout)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 528,
  maxWidth: 528,
  background: 'none',
  padding: 32,
  paddingBottom: 96,

  flex: 1,

  '.auth-content': {
    flex: 1,
    justifyContent: 'center',
  } as CSSObject,
}));

export const CanvasStyled = styled('canvas')(() => ({
  width: '100%',
  height: '100%',
  '--gradient-color-1': '#65CDFA',
  '--gradient-color-2': '#a1dff5',
  '--gradient-color-3': '#C3DBFF',
  '--gradient-color-4': '#f8fcff',
  zIndex: 0,
  pointerEvents: 'none',
}));
